export function getTransactionsWithNotes(transactions) {
  return transactions.filter(t => !!t.notes)
}
